import { render } from "./CreateVendorModal.vue?vue&type=template&id=1bed64f6"
import script from "./CreateVendorModal.vue?vue&type=script&lang=js"
export * from "./CreateVendorModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__